import * as DateFns from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';

import Navbar from '../Navbar/NavBar';
import GameHead from './GameHead';
import Loader from '../Shared/Loader';
import PracticeHead from './PracticeHead';
import TabPerformance from './TabPerformance';
import TabReports from './TabReports/TabReports';
import TabBallMetrics from './TabBallMetrics/TabBallMetrics';
import Manage from '../../components/Viewer/TabManage/TabManage';
import GameManage from '../../components/Viewer/TabGameManage/TabGameManage';
import {
  isDataEventsOnLocalStorage,
  isIn,
  isJustFinished,
  routeToViewPracticeGamePageScope,
  saveDataEventsOnLocalStorage,
  shouldDisplayPracticeViewer
} from '../../helpers';
import {
  BALL,
  GAME,
  LIVE_PRACTICE,
  LOAD_EVENTS_TIME_LIVE_PAGE,
  MINUTES_WAITING_DATA_TIME,
  PAST_PRACTICE,
  PERFORMANCE,
  PLAYERS_DATA,
  PRACTICE,
  PAST_GAME
} from '../../config/constants';
import { useEventListener, useInterval, useRouter } from '../../helpers/customHooks';
import PracticeViewer from './PracticeViewer/PracticeViewer';
import { ProgressBar } from './ProgressBar/ProgressBarView';

import 'react-accessible-accordion/dist/fancy-example.css';
import { useDataEventsDispatch, useDataEventsState, usePlayersState } from '../../store/hooks';
import { ViewerRoutes } from './types';
import { DataMeta } from '../../config/commonTypes';
import  CombineLogger  from './CombineLogger/CombineLogger';
import EventLoggerMobile from './LoggerMobile/EventLoggerMobile';
import PracticeTracking from './TabPracticeTracking/PracticeTracking';
import { LiveSpeedsPlayerList } from './LiveSpeedsModal/types';

export default () => {

  const { dataEvent: data, meta: dataMeta } = useDataEventsState();
  const {
    getLiveData,
    getScheduleData,
    loadDataMetaGame,
    loadPlayersSession,
    livePracticePlayers,
    loadPracticePlayers,
    cleanPlayersSession,
    getTeamPracticeFields,
    cleanPracticeViewerData,
    loadDataProcessingStatus,
    loadDataEventsOnLocalStorage
  } = useDataEventsDispatch();
  const { pathname, eventType, params, location } = useRouter<ViewerRoutes>();
  const { tab, id: gameId } = params;
  const { excludedPlayers } = usePlayersState();
  const listOfPlayersExcluded = excludedPlayers && excludedPlayers[gameId] ? excludedPlayers[gameId].join(',') : null;
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const teamId = dataMeta?.homeTeam?.teamId;
  const [hidden, setHidden] = useState(false);
  const [targetedReprocess, setTargetedReprocess] = useState(false);
  const [targetedPlayeres, setTargetedPlayers] = useState<string[]>([]);
  const [updateSpeeds, setUpdateSpeeds] = useState(false);
  const [selectedPlayers, setSelectedPlayers] = useState<LiveSpeedsPlayerList>([]);
  const [showUpdateSpeeds, setShowUpdateSpeeds] = useState(false);

  const [openDrawer, setOpenDrawer] = useState(false);

  useEventListener('visibilitychange', () => {
    if (dataMeta && dataMeta.type === LIVE_PRACTICE) {
      if (!document.hidden) {
        getScheduleData(isMobile);
        if (tab === PERFORMANCE) {
          getLiveData(false, dataMeta.teamId, listOfPlayersExcluded);
        }
      }
      setHidden(document.hidden);
    }
  });
  useInterval(() => {
    getScheduleData(isMobile);
  }, !hidden && dataMeta && dataMeta.type === LIVE_PRACTICE ? LOAD_EVENTS_TIME_LIVE_PAGE : null);
  // TODO: Check those useEffects
  useEffect(() => {
    if (dataMeta && dataMeta.gameId) {
      getScheduleData(isMobile);
      saveDataEventsOnLocalStorage([dataMeta.gameId]);
    }

    if (data && data.meta) {
      if ((data.meta.type === PAST_PRACTICE || data.meta.gameType === "ncaa") && !isMobile && !isJustFinished(dataMeta)) {
        loadPlayersSession(data.meta.startTime, data.meta.homeTeam.teamId);
      }
      if ((eventType === PRACTICE || data.meta.gameType === "ncaa") && shouldDisplayPracticeViewer(data) && !isMobile) {
        
        if (data.meta.type === PAST_PRACTICE) {
          loadPracticePlayers();
        } else {
          livePracticePlayers(data.meta.startTime);
        }
        getTeamPracticeFields(data.meta.homeTeam.teamId);
      }
    }

    return () => {
      if (data && data.meta && data.meta.type && (eventType === PRACTICE || data.meta.gameType === "ncaa") && shouldDisplayPracticeViewer(data)) {
        cleanPracticeViewerData();
      }
    };
  }, [data]);
  useEffect(() => { // for the head of game
    if (eventType === GAME) {
      loadDataMetaGame();
    }
    return () => {
      if (data && data.meta && data.meta.type === PAST_PRACTICE) {
        cleanPlayersSession();
      }
    };
  }, []);

  useEffect(() => {
    if (dataMeta?.type) {
      saveDataEventsOnLocalStorage([dataMeta.gameId]);
    }
  }, [dataMeta?.type, hidden]);

  useEffect(() => {
    if (data && data.meta && data.meta.type === PAST_PRACTICE && !isMobile && DateFns.isToday(dataMeta.endTime)) {
      loadDataProcessingStatus(dataMeta.endTime, teamId, true);
    }
  }, [data?.meta?.type]);
  
  /**** BEGIN force to request data a past data ****/
  const [hasUpdate, setHasUpdate] = useState<number>(0);
  const timeOut = useRef<NodeJS.Timeout | null>(null); // couldn't find proper type
  useEffect(() => {
    if (isJustFinished(dataMeta)) {
      // to change the message and clean the live data if kept live data
      timeOut.current = setTimeout(() => setHasUpdate(prevState => prevState + 1),
        MINUTES_WAITING_DATA_TIME * 60 * 1000 - DateFns.differenceInMilliseconds(new Date(), new Date(dataMeta.endTime)) + LOAD_EVENTS_TIME_LIVE_PAGE);
    }
  }, [gameId, dataMeta]);
  // only for past practices
  useInterval(() => setHasUpdate(prevState => prevState + 1),
    (
      !hidden && dataMeta && isJustFinished(dataMeta) && data.data && data.data.players &&
      (dataMeta[routeToViewPracticeGamePageScope(pathname)] === PLAYERS_DATA.LIVE ||
        ((data.data.players.length === 0 && tab === PERFORMANCE) || (data.data.playersBall.length === 0 && tab === BALL)))
    ) ?
      LOAD_EVENTS_TIME_LIVE_PAGE : null);
  if (dataMeta && (dataMeta[routeToViewPracticeGamePageScope(pathname)] === PLAYERS_DATA.PAST)) {
    clearTimeout(timeOut.current as NodeJS.Timeout);
  }
  /**** END force to request data a past data ****/
  if (data?.validGameId) {
    const oldPathname = location.pathname;
    const params = location.pathname.split('/');
    params[3] = data.validGameId;
    const newPathname = params.join('/');
    if (oldPathname !== newPathname) {
      return <Redirect to={{ pathname: newPathname, state: location.state }} />;
    }
  }
  if (!data || !dataMeta) {
    if (eventType === GAME || isDataEventsOnLocalStorage(gameId)) {
      if (eventType === PRACTICE || eventType === GAME) {
        loadDataEventsOnLocalStorage();
      }
      return (<>
        <Navbar />
        <Container className="container-00">
          <Loader style={{ height: '100%' }} />
        </Container>
      </>);
    } else {
      return <Redirect to={'/practices'} />;
    }
  }
  const updateTargetedPlayers = (args: string[])=>{
    let newCopyPlayersContent = [...targetedPlayeres];
    args.forEach((value) => {
      if (isIn(newCopyPlayersContent, value)) {
        newCopyPlayersContent = newCopyPlayersContent.filter(pos => (pos !== value));
      } else {
        newCopyPlayersContent.push(value);
      }
    }); 
    setTargetedPlayers(newCopyPlayersContent);
  };
    const updateSelectedPlayers = (args: LiveSpeedsPlayerList)=>{
    let newCopyPlayersContent = [...selectedPlayers];
    args.forEach((value) => {
      if (newCopyPlayersContent?.some(p => p.id === value.id) ) {
        newCopyPlayersContent = newCopyPlayersContent.filter(pos => (pos.id !== value.id));
      } else {
        newCopyPlayersContent.push(value);
      }
    }); 
    setSelectedPlayers(newCopyPlayersContent);
  };
  const routeForProgress = routeToViewPracticeGamePageScope(pathname).split(':');
  if (routeForProgress[0] === 'VIEW_PRACTICE_BALL') {
    routeForProgress[0] = 'VIEW_PRACTICE_PERFORMANCE_PAGE';
  }
  const forceRouteForProgress = routeForProgress.join(':');
  const shouldDisplayProgressBar = (!+dataMeta.completePercentProcessingStatus || +dataMeta.completePercentProcessingStatus*100 < 100) &&
    (tab === PERFORMANCE || tab === BALL) && isJustFinished(dataMeta) &&
    (dataMeta[forceRouteForProgress] !== PLAYERS_DATA.PAST || (data.data.players.length === 0 ));
  const isInProgress = (!+dataMeta.completePercentProcessingStatus || +dataMeta.completePercentProcessingStatus*100 < 100) && isJustFinished(dataMeta);
  return (
    <>
      <Navbar />
      <Container className="container-00">
        <Row>
          <Col lg={12} xs={12}>
            {eventType === GAME ? <GameHead /> : <PracticeHead setTargetedReprocess={setTargetedReprocess} targetedReprocess={targetedReprocess} setTargetedPlayers={setTargetedPlayers}
            updateSpeeds={updateSpeeds} setUpdateSpeeds={setUpdateSpeeds} selectedPlayers={selectedPlayers} showUpdateSpeeds={showUpdateSpeeds} setShowUpdateSpeeds={setShowUpdateSpeeds}
            targetedPlayers={targetedPlayeres} dataInProgress={shouldDisplayProgressBar} setOpenDrawer={setOpenDrawer} openDrawer={openDrawer} setSelectedPlayers={setSelectedPlayers} />}
            <Tabs activeKey={tab} id="uncontrolled-tab-example" mountOnEnter unmountOnExit style={{ display: 'none' }}>
              <Tab eventKey="performance" title="Performance">
                <TabPerformance shouldDisplayProgressBar={shouldDisplayProgressBar} hidden={hidden} hasUpdate={hasUpdate}
                 targetedReprocess={targetedReprocess} targetedPlayers={targetedPlayeres} 
                 updateTargetedPlayers={updateTargetedPlayers} setOpenDrawer={setOpenDrawer} openDrawer={openDrawer}
                 updateSpeeds={updateSpeeds} updateSelectedPlayers={updateSelectedPlayers} selectedPlayers={selectedPlayers} showUpdateSpeeds={showUpdateSpeeds}
                  setShowUpdateSpeeds={setShowUpdateSpeeds} setSelectedPlayers={setSelectedPlayers} setUpdateSpeeds={setUpdateSpeeds}/>
              </Tab>
              <Tab eventKey="manage" title="Manage">
                <Manage />
              </Tab>
              <Tab eventKey="game_manage" title="Game Manage">
              <GameManage/>
              </Tab>
              <Tab eventKey="combine" title="Combine Logger">
                <CombineLogger/>
              </Tab>
              <Tab eventKey="event" title="Event Logger">
              <EventLoggerMobile/>
              </Tab>
              {(eventType === PRACTICE || PAST_GAME) && <Tab eventKey="ball" title="Ball Metrics">
                <TabBallMetrics hidden={hidden} hasUpdate={hasUpdate} isInProgress={shouldDisplayProgressBar} />
              </Tab>}
              {dataMeta.type !== LIVE_PRACTICE && <Tab eventKey="report" title="Reporting">
                <TabReports />
              </Tab>}
              <Tab eventKey="map" title="Practice Viewer">
                <PracticeViewer shouldDisplayProgressBar={isInProgress} isNcaaGame={ data.meta.type === PAST_GAME && data.meta.gameType === "ncaa"}/>
              </Tab>
              <Tab eventKey="tracking" title="Practice Tracking">
                <PracticeTracking/>
              </Tab>
            </Tabs>
          </Col>
        </Row>
        {shouldDisplayProgressBar && (
          <ProgressBar
            endTime={dataMeta.endTime}
            teamId={teamId}
            loadDataProcessingStatus={loadDataProcessingStatus}
            hidden={hidden}
            completePercent={dataMeta.completePercentProcessingStatus}
          />
        )}
      </Container>
    </>
  );
};
